// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.admin-only-note__text[data-v-78b4ce6c] {\n  padding-bottom: 2px;\n  padding-left: 20px;\n  font-size: 10px;\n  text-align: left;\n}\n", ""]);
// Exports
module.exports = exports;
